import React from "react";
import { Link } from "react-router-dom";

import INFO from "../../data/user";
import { track } from "../../lib/analytics";

import "./styles/aboutBuilder.css";

// Closing "about the builder" strip, shown at the bottom of every page except
// the home page. Catches a visitor who reached the end of a page and now wants
// to know who is behind the work, with a warm bio and two clear next steps.
const AboutBuilder = ({ context }) => (
	<div className="about-builder">
		<img
			className="about-builder-photo"
			src="/swap-blue.jpg"
			alt="Swapnil Tamse"
		/>
		<div className="about-builder-text">
			<h3 className="about-builder-name">Swapnil Tamse</h3>
			<p className="about-builder-bio">
				Engineering leader working in AI and AI governance.{" "}
				{context ||
					"Most of these projects started as a question I wanted answered, then turned into something you can click."}
			</p>
			<div className="about-builder-links">
				<a
					href={INFO.socials.linkedin}
					className="about-builder-cta"
					target="_blank"
					rel="noopener noreferrer"
					onClick={() => track("get-in-touch", { dest: "linkedin" })}
				>
					Get in touch
				</a>
				<Link
					to="/about"
					className="about-builder-cta about-builder-cta-secondary"
				>
					More about me
				</Link>
			</div>
		</div>
	</div>
);

export default AboutBuilder;
